import { Expose, Transform, Type } from "class-transformer";
import { IsString } from "class-validator";
import { CreateFileDto } from "@/core/features/file/create-file.dto";
import { parseAppDate } from "@/utils/dates/dateFormats";
import { setTimeToMidday, toLocaleTimezone } from "@/utils/dates/dateUtils";

export class UpdateUserChangeHolidayDto {
  @Expose()
  @IsString()
  id: string;

  @Expose()
  @Transform(({ value }) => {
    const parsedUtc = parseAppDate(value, false);
    const localDate = toLocaleTimezone(parsedUtc);
    const localMidday = setTimeToMidday(localDate);
    return localMidday.toISOString();
  })
  newDate: string;

  @Expose()
  @Type(() => CreateFileDto)
  file?: CreateFileDto;
}
